import { render } from "./PainelDash.vue?vue&type=template&id=0ff2a7f8&scoped=true"
import script from "./PainelDash.vue?vue&type=script&lang=js"
export * from "./PainelDash.vue?vue&type=script&lang=js"

import "./PainelDash.vue?vue&type=style&index=0&id=0ff2a7f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff2a7f8"]])

export default __exports__